import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component({
  name: 'CmgInlineLoader',
})
export default class CmgButton extends Vue {

  @Prop({ default: 'white', type: String })
  public spinningCircleColor!: string;
  
  get spinningCircleClass(): string {
    return `color-${this.spinningCircleColor}`;
  }
}
